import {
  dateMonthValueFormatter,
  dateValueFormatter,
  dateValueSetter,
  dtimeValueFormatter,
  dtimeValueGetter,
  dtimeValueSetter,
  intervalCellRender,
  intervalSetter,
} from "../../functions/time.function";
import { valSetter } from "../helpers";

export const SETTLE_COLUMN_NAMES = {
  dtime: "Sesión",
  instrument: "Producto",
  settle_price1: "Precio 1",
  settle_bid1: "Bid 1",
  settle_ask1: "Ask 1",
  settle_price2: "Precio 2",
  settle_bid2: "Bid 2",
  settle_ask2: "Ask 2",
  settle_price3: "Precio 3",
  settle_bid3: "Bid 3",
  settle_ask3: "Ask 3",
  settle_tullet: "Precio 4",
  settle_omip: "OMIP",
  settle: "Precio Último",
  settle_bid: "Bid Último",
  settle_ask: "Ask Último",
  settle_quality_factor: "Factor de Calidad",
  settle_modified: "Modificar Precio Último",
  settle_reference_time: "Inicio Ventana Precio 1",
  settle_last_modification: "Última Modificación",
};
export const SETTLE_COLS = [
  "settle_price1",
  "settle_price2",
  "settle_price3",
  "settle_tullet",
  "settle_omip",
];
export const DEC_COLS = [
  "settle_price1",
  "settle_bid1",
  "settle_ask1",
  "settle_price2",
  "settle_bid2",
  "settle_ask2",
  "settle_price3",
  "settle_bid3",
  "settle_ask3",
  "settle_tullet",
  "settle_omip",
  "settle",
  "settle_bid",
  "settle_ask",
];
const browserProtocol =
  typeof window !== "undefined"
    ? window.location.protocol.replace(":", "")
    : null;
export const PROTOCOL =
  process.env.REACT_APP_PROTOCOL || browserProtocol || "https";
export const URL =
  process.env.REACT_APP_LOCAL_BACKEND_URL || window.location.host;
export const TTF_STATUS_POLL_INTERVAL_MS = 30000;

export const MI_COLUMNS = [
  {
    field: "dtime",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Sesión de negociación",
    width: 120,
    editable: false,
  }, // groups:

  {
    field: "bid_volume",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Volumen total (MWh)",
    width: 120,
    editable: true,
  }, // groups: OFERTAS / COMPRA /

  {
    field: "bid_price_mean",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Precio medio ponderado",
    width: 120,
    editable: true,
  }, // groups: OFERTAS / COMPRA /

  {
    field: "ask_volume",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Volumen total (MWh)",
    width: 120,
    editable: true,
  }, // groups: OFERTAS / VENTA/

  {
    field: "ask_price_mean",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Precio medio ponderado",
    width: 120,
    editable: true,
  }, // groups: OFERTAS / VENTA/

  {
    field: "maxspread",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Máxima separación de precios permitida (€/MWh)",
    width: 145,
    editable: true,
  }, // groups: OFERTAS /

  {
    field: "spread_vwap",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Media diaria separación de precios (€/MWh)",
    width: 130,
    editable: true,
    valueSetter: valSetter,
  }, // groups: OFERTAS /

  {
    field: "trade_buy",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Número de transacciones",
    width: 120,
    editable: true,
  }, // groups: TRANSACCIONES BAJO CUMPLIMIENTO / COMPRA /

  {
    field: "trade_volume_buy",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Volumen total (MWh)",
    width: 120,
    editable: true,
  }, // groups: TRANSACCIONES BAJO CUMPLIMIENTO / COMPRA /

  {
    field: "trade_price_buy_mean",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Precio medio ponderado",
    width: 120,
    editable: true,
  }, // groups: TRANSACCIONES BAJO CUMPLIMIENTO / COMPRA /

  {
    field: "trade_sell",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Número de transacciones",
    width: 120,
    editable: true,
  }, // groups: TRANSACCIONES BAJO CUMPLIMIENTO / VENTA/

  {
    field: "trade_volume_sell",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Volumen total (MWh)",
    width: 120,
    editable: true,
  }, // groups: TRANSACCIONES BAJO CUMPLIMIENTO / VENTA /

  {
    field: "trade_price_sell_mean",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Precio medio ponderado",
    width: 120,
    editable: true,
  }, // groups: TRANSACCIONES BAJO CUMPLIMIENTO / VENTA/

  {
    field: "trade_volume_fulfilled",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Volumen total bajo cumplimiento (MWh)",
    width: 140,
    editable: true,
  }, // groups: CUMPLIMIENTO /

  {
    field: "maxvolume_daily",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "VDMC (MWh)",
    width: 120,
    editable: true,
  }, // groups: CUMPLIMIENTO /

  {
    field: "maxsize_time",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Hora a la que se alcanza el VDMC",
    width: 120,
    editable: true,
  }, // groups: CUMPLIMIENTO /

  {
    field: "slottime",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Franjas horarias establecidas",
    width: 120,
    editable: true,
  }, // groups: CUMPLIMIENTO /

  {
    field: "slottime_evaluate",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Franjas horarias a evaluar",
    width: 120,
    editable: true,
  }, // groups: CUMPLIMIENTO /

  {
    field: "time_evaluated",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Minutos totales a evaluar",
    valueGetter: intervalCellRender,
    valueSetter: intervalSetter,
    width: 120,
    editable: true,
    type: "number",
  }, // groups: CUMPLIMIENTO /

  {
    field: "time_exonerated",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Minutos exención",
    valueGetter: intervalCellRender,
    valueSetter: intervalSetter,
    width: 120,
    editable: true,
    type: "number",
  }, // groups: CUMPLIMIENTO /

  {
    field: "time_fm",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Minutos en FM",
    valueGetter: intervalCellRender,
    valueSetter: intervalSetter,
    width: 120,
    editable: true,
    type: "number",
  }, // groups: CUMPLIMIENTO /

  {
    field: "time_fm_fulfilled",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Minutos en FM cumplidos",
    valueGetter: intervalCellRender,
    valueSetter: intervalSetter,
    width: 120,
    editable: true,
    type: "number",
  }, // groups: CUMPLIMIENTO /

  {
    field: "time_sm",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Minutos en SM",
    valueGetter: intervalCellRender,
    valueSetter: intervalSetter,
    width: 120,
    editable: true,
    type: "number",
  }, // groups: CUMPLIMIENTO /

  {
    field: "time_sm_fulfilled",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Minutos en SM cumplidos",
    valueGetter: intervalCellRender,
    valueSetter: intervalSetter,
    width: 120,
    editable: true,
    type: "number",
  }, // groups: CUMPLIMIENTO /

  {
    field: "time_nc_fulfilled",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Minutos en condiciones normales cumplidos",
    valueGetter: intervalCellRender,
    valueSetter: intervalSetter,
    width: 160,
    editable: true,
    type: "number",
  }, // groups: CUMPLIMIENTO /

  {
    field: "time_fulfilled",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Minutos cumplidos",
    valueGetter: intervalCellRender,
    valueSetter: intervalSetter,
    width: 120,
    editable: true,
    type: "number",
  }, // groups: CUMPLIMIENTO /

  {
    field: "time_not_fulfilled",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "Minutos no cumplidos",
    valueGetter: intervalCellRender,
    valueSetter: intervalSetter,
    width: 120,
    editable: true,
    type: "number",
  }, // groups: CUMPLIMIENTO /

  {
    field: "recommendation",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "RECOMENDACIÓN",
    width: 150,
    editable: true,
    type: "singleSelect",
    valueOptions: ["OK", "NOOK", "EXO", "EXC"],
  }, // groups:

  {
    field: "evaluation",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    align: "center",
    headerAlign: "center",
    headerName: "EVALUACIÓN",
    width: 120,
    editable: true,
    type: "singleSelect",
    valueOptions: ["OK", "NOOK", "EXO", "EXC"],
  }, // groups:
];

export const COLUMN_GROUPING_MODEL = [
  {
    groupId: "OFERTAS",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2 content-center",
    description: "",
    children: [
      {
        groupId: "COMPRA",
        headerAlign: "center",
        description: "",
        children: [{ field: "bid_volume" }, { field: "bid_price_mean" }],
      },
      {
        groupId: "VENTA",
        headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
        children: [{ field: "ask_volume" }, { field: "ask_price_mean" }],
      },
      { field: "maxspread" },
      {
        field: "spread_vwap",
        headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      },
    ],
  },
  {
    groupId: "TRANSACCIONES BAJO CUMPLIMIENTO",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
    children: [
      {
        groupId: "COMPRA",
        headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
        children: [
          { field: "trade_buy" },
          { field: "trade_volume_buy" },
          { field: "trade_price_buy_mean" },
        ],
      },
      {
        groupId: "VENTA",
        headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
        children: [
          { field: "trade_sell" },
          { field: "trade_volume_sell" },
          { field: "trade_price_sell_mean" },
        ],
      },
    ],
  },
  {
    groupId: "CUMPLIMIENTO",
    headerClassName: "bg-cyan-500 text-white sticky top-0 p-2 content-center",
    description: "",
    children: [
      { field: "trade_volume_fulfilled" },
      { field: "maxvolume_daily" },
      { field: "maxsize_time" },
      { field: "slottime" },
      { field: "slottime_evaluate" },
      { field: "time_evaluated" },
      { field: "time_exonerated" },
      { field: "time_fm" },
      { field: "time_fm_fulfilled" },
      { field: "time_sm" },
      { field: "time_sm_fulfilled" },
      { field: "time_nc_fulfilled" },
      { field: "time_fulfilled" },
      { field: "time_not_fulfilled" },
    ],
  },
];

export const CONDITIONS_MI_COLUMNS = {
  mmcompanies: [
    {
      field: "dtime",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Mes",
      width: 140,
      editable: false,
      valueFormatter: dateMonthValueFormatter,
    },

    {
      field: "market_maker",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Código CM",
      width: 120,
      editable: true,
    },

    {
      field: "company_name",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Denominación social",
      width: 300,
      editable: true,
    },
  ],
  mmconditions: [
    {
      field: "dtime",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Inicio condiciones",
      width: 140,
      editable: true,
      type: "date",
      valueGetter: dtimeValueGetter,
      valueFormatter: dateValueFormatter,
      valueSetter: dateValueSetter,
    },
    {
      field: "market_maker",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Código CM",
      width: 120,
      editable: true,
    },
    {
      field: "product",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Producto",
      width: 120,
      editable: true,
    },
    {
      field: "market_maker_type",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Tipo de CM",
      width: 120,
      editable: true,
    },
    {
      field: "product_type",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Tipo de producto",
      width: 120,
      editable: true,
    },
    {
      field: "minsize",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Cantidad mínima ofertada (MWh/d)",
      width: 120,
      editable: true,
    },
    {
      field: "maxspread",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Máxima separación de precios permitida",
      width: 120,
      editable: true,
    },
    {
      field: "maxspread_sm",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Máxima separación durante SM",
      width: 120,
      editable: true,
    },
    {
      field: "maxspread_fm",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Máxima separación durante FM",
      width: 120,
      editable: true,
    },
    {
      field: "spread_vtp_percentage",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Porcentaje usado para calcular el spread porcentual",
      width: 180,
      editable: true,
    },
    {
      field: "minspread_vtp",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Mínimo spread porcentual",
      width: 120,
      editable: true,
    },
    {
      field: "maxspread_vtp",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Máximo spread porcentual",
      width: 120,
      editable: true,
    },
    {
      field: "maxvolume_daily",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Volumen máximo a casar (MWh)",
      width: 120,
      editable: true,
    },
    {
      field: "maxsize_daily",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Cantidad máxima a casar (MWh/d)",
      width: 120,
      editable: true,
    },
    {
      field: "continue_after_vdmc",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Medir volumen tras VDMC",
      width: 120,
      editable: true,
      type: "boolean",
      valueOptions: [true, false],
    },
    {
      field: "replacement_time",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Tiempo de reposición",
      width: 120,
      editable: true,
      type: "number",
      valueGetter: intervalCellRender,
      valueSetter: intervalSetter,
    },
    {
      field: "exoneration_time",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Porcentaje de exoneración",
      width: 120,
      editable: true,
    },
    {
      field: "slottime",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Franjas de cumplimiento",
      width: 190,
      editable: true,
    },
    {
      field: "import",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Importe mensual",
      width: 120,
      editable: true,
    },
    {
      field: "increment_after_maxsize_daily",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Incremento tras VDMC",
      width: 120,
      editable: true,
    },
    {
      field: "mindays",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Mínimo días para contar días de exoneración",
      width: 120,
      editable: true,
    },
    {
      field: "import_fm",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Incremento por actividad durante FM",
      width: 120,
      editable: true,
    },
  ],
  mmspreads: [
    {
      field: "dtime",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Mes",
      width: 140,
      editable: false,
      valueFormatter: dateMonthValueFormatter,
    },
    {
      field: "market_maker",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Código CM",
      width: 100,
      editable: true,
    },
    {
      field: "product",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Producto",
      width: 120,
      editable: true,
    },
    {
      field: "start_level",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Inicio rango de precios",
      width: 120,
      editable: true,
    },
    {
      field: "maxspread_sm",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Máxima separación durante SM",
      width: 120,
      editable: true,
    },
  ],
  mmexonerationdays: [
    {
      field: "dtime",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Día de exoneración",
      width: 120,
      editable: true,
      type: "date",
      valueGetter: dtimeValueGetter,
      valueFormatter: dateValueFormatter,
      valueSetter: dateValueSetter,
    },
    {
      field: "market_maker",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Código CM",
      width: 120,
      editable: true,
    },
    {
      field: "product",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Producto",
      width: 120,
      editable: true,
    },
  ],
  marketconditions: [
    {
      field: "dtime",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Inicio escenario",
      width: 160,
      editable: true,
      type: "dateTime",
      valueGetter: dtimeValueGetter,
      valueFormatter: dtimeValueFormatter,
      valueSetter: dtimeValueSetter,
    },
    {
      field: "product",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Producto",
      width: 120,
      editable: true,
    },
    {
      field: "market_conditions",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Escenario detectado",
      width: 120,
      editable: true,
      type: "singleSelect",
      valueOptions: ["SM", "FM"],
    },
    {
      field: "period_end",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Fin escenario",
      width: 160,
      editable: true,
      type: "dateTime",
      valueGetter: dtimeValueGetter,
      valueFormatter: dtimeValueFormatter,
      valueSetter: dtimeValueSetter,
    },
    {
      field: "start_level",
      headerClassName: "bg-cyan-500 text-white sticky top-0 p-2",
      align: "center",
      headerAlign: "center",
      headerName: "Nivel de precios",
      width: 120,
      editable: true,
    },
  ],
};

export const CRITERION_COLORS = {
  Normal: "#16a34a", // tailwind green-600
  SMC: "#ea580c", // tailwind orange-600
  FM: "#92400e", // tailwind amber-800
  Warning: "#bef264", // tailwind lime-300
};

export const TOLL_PERIODS = [
  { key: "toll_withinday", label: "Intradiario" },
  { key: "toll_daily", label: "Diario" },
  { key: "toll_monthly", label: "Mensual" },
  { key: "toll_quarterly", label: "Trimestral" },
  { key: "toll_yearly", label: "Anual" },
];

// Rutas de peaje conocidas que deben mostrarse como columnas aunque no tengan
// datos en BD para el año seleccionado (MIBCORRPU-8).
export const KNOWN_TOLL_PATHS = {
  tvb: ["PVB-TVB", "TVB-PVB"],
  vtp: ["PVB-VTP", "VTP-PVB"],
  avb: ["PVB-AVB", "AVB-PVB"],
};

export const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;
export const POSTHOG_PROJECT_TOKEN =
  process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;
